import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import TypeWriter from './TypeWriter';
import {
  aigcReplysWritingEnd,
  aigcReplyWritingStop,
  aigcReplyIsBusing,
  aigcShowDialog,
} from '../../../../actions/aigc';
import { setDownloadVisible } from '../../../../actions/layout';
import { logging, logPostInfo } from '../../../../actions/log';
import { CONTEXT } from '../../../../config';

const selectIsBusing = createSelector(
  state => state.aigc,
  aigc => aigc.isBusing,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(
  ({ styles, answerIndex, answerItem, answerIndexShow, h5IDAll, start = () => {}, userText }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const isBusing = useSelector(selectIsBusing);
    const logInfoData = useSelector(selectLogInfo);

    useEffect(() => {
      dispatch(aigcReplyIsBusing({ isBusing: 5 }));
    }, []);

    const handleDowntask = ev => {
      ev.stopPropagation();
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Aigc_Task',
          label: '',
          param2: {
            search_word: userText,
          },
        }),
      );
      dispatch(aigcShowDialog(false));
      dispatch(setDownloadVisible(true));
    };

    const handleJump = (info, index) => {
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Aigc_View',
          label: '',
          param2: {
            softid: info?.softID,
            search_word: userText,
          },
          param3: {
            ...JSON.parse(info?.bizInfo),
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: `AIGC_${logInfoData.source}`,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(`${CONTEXT}/detail/soft/${info.softID}/${info.bizInfo || '{}'}`);
      dispatch(aigcShowDialog(false));
    };

    return (
      <>
        <>
          {answerIndexShow && <span className={styles.chat_index}>回答{answerIndex}</span>}
          {answerItem?.commandMsg?.tip && (
            <span className={styles.chat}>
              {answerItem?.commandMsg?.tip} 点击打开
              <span className={styles.soft_operate} onClick={e => handleDowntask(e)}>
                任务管理器
              </span>
            </span>
          )}
          {answerItem?.commandMsg?.errorApplist?.length > 0 && (
            <>
              {answerItem?.commandMsg?.errorApplist?.map((item, index) => (
                <span key={index}>
                  {item?.softName}不支持直接下载安装，请点击进入{' '}
                  <span className={styles.soft_operate} onClick={() => handleJump(item, index + 1)}>
                    应用详情
                  </span>{' '}
                  后操作
                </span>
              ))}
            </>
          )}
        </>
      </>
    );
  },
);
